import React, { SVGProps } from 'react'
const SvgStatusSummaryActionRequiredRed = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={121}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#StatusSummaryActionRequiredRed_svg__a)">
      <path
        fill="#EAEBF1"
        fillRule="evenodd"
        d="M109.792 75H77.268c-.667 0-1.208.54-1.208 1.207v1.69c0 .666.54 1.206 1.208 1.206h32.524c.667 0 1.208-.54 1.208-1.206v-1.69c0-.667-.541-1.207-1.208-1.207ZM28.724 56H6.208C5.541 56 5 56.54 5 57.207v1.69c0 .666.54 1.206 1.208 1.206h22.516c.667 0 1.208-.54 1.208-1.206v-1.69c0-.667-.54-1.207-1.208-1.207ZM106.79 38H94.282c-.667 0-1.208.54-1.208 1.207v1.69c0 .666.54 1.206 1.208 1.206h12.508c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207Z"
        clipRule="evenodd"
      />
      <g filter="url(#StatusSummaryActionRequiredRed_svg__b)">
        <path
          fill="#D5404A"
          d="M57.106 11.29a3.72 3.72 0 0 1 2.878 0l36.781 15.417a3.79 3.79 0 0 1 2.314 3.5v18.74c0 25.807-15.45 49.02-39.116 58.772a3.717 3.717 0 0 1-2.836 0C33.46 97.967 18.01 74.754 18.01 48.948V30.206a3.79 3.79 0 0 1 2.314-3.5l36.78-15.416Z"
        />
        <path
          fill="#C11622"
          d="m56.525 9.907-36.78 15.417-.227.101a5.306 5.306 0 0 0-3.008 4.781v18.742l.004.782c.313 26.12 16.068 49.498 40.04 59.376a5.229 5.229 0 0 0 3.981 0c24.23-9.984 40.045-33.746 40.045-60.158V30.206l-.006-.248c-.111-2.064-1.362-3.852-3.228-4.634L60.565 9.906l-.301-.115a5.222 5.222 0 0 0-3.74.116Zm2.742 2.714.18.07L96.183 28.09a2.288 2.288 0 0 1 1.39 1.99l.004.167v18.7c0 25.201-15.085 47.866-38.187 57.385a2.214 2.214 0 0 1-1.692 0c-22.856-9.418-37.884-31.715-38.182-56.629l-.005-.764V30.206c0-.884.501-1.686 1.281-2.065l.15-.067 36.744-15.401c.45-.189.946-.223 1.414-.102l.166.05Z"
        />
      </g>
      <g fill="#F6F7FB" filter="url(#StatusSummaryActionRequiredRed_svg__c)">
        <path d="M58.733 30.17c1.696 0 3.1 1.248 3.342 2.876l.036.499V65.83a3.376 3.376 0 0 1-3.378 3.375 3.378 3.378 0 0 1-3.34-2.876l-.038-.499V33.545a3.376 3.376 0 0 1 3.378-3.375ZM58.77 75.134c1.696 0 3.1 1.249 3.341 2.876l.037.5v1.902a3.378 3.378 0 0 1-6.719.499l-.037-.499V78.51a3.376 3.376 0 0 1 3.378-3.375Z" />
      </g>
    </g>
    <defs>
      <filter
        id="StatusSummaryActionRequiredRed_svg__b"
        width={104.071}
        height={120}
        x={6.51}
        y={3.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1222_1140"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1222_1140"
          result="shape"
        />
      </filter>
      <filter
        id="StatusSummaryActionRequiredRed_svg__c"
        width={26.792}
        height={73.618}
        x={45.355}
        y={24.17}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1222_1140"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1222_1140"
          result="shape"
        />
      </filter>
      <clipPath id="StatusSummaryActionRequiredRed_svg__a">
        <path fill="#fff" d="M0 0h120v121H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgStatusSummaryActionRequiredRed
